var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{class:[_vm.$style.iconButton, _vm.$style.iconButtonSize],attrs:{"href":_vm.href,"rel":_vm.rel,"target":_vm.target,"title":_vm.title}},[_vm._t("default")],2):_c('button',{class:[_vm.$style.iconButton, _vm.$style.iconButtonSize],attrs:{"title":_vm.title},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }